import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  buildTournamentRuntime,
  getTournamentConfigFromPath,
} from "../config/tournamentConfig";
import { setTournamentRuntime } from "../config/tournamentRuntime";

const TournamentContext = createContext(null);

export const TournamentProvider = ({ children }) => {
  const { pathname } = useLocation();

  const tournament = useMemo(() => {
    const config = getTournamentConfigFromPath(pathname);
    return buildTournamentRuntime(config);
  }, [pathname]);

  // Set the active DB during render so score listeners/writes never race
  // against a useEffect (child effects otherwise run first with a null DB).
  setTournamentRuntime(
    tournament.db,
    tournament.teamMappingService,
    tournament.poolMaxTeams,
    {
      readOnly: tournament.readOnly,
      round1ScoringLocked: tournament.round1ScoringLocked,
      round2ScoringEnabled: tournament.round2ScoringEnabled,
    }
  );

  return (
    <TournamentContext.Provider value={tournament}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournament = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error("useTournament must be used within TournamentProvider");
  }
  return context;
};
